import styled from "@emotion/styled";

export const ContainerSC = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const WrapperSC = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
